import AntDesign from '@expo/vector-icons/build/AntDesign';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import Text from '../Text';
interface AddAnotherButtonProps {
  onPress: () => void;
  label: string;
}

const AddAnotherButton = ({ onPress, label }: AddAnotherButtonProps) => (
  <TouchableOpacity onPress={onPress}>
    <View style={styles.container}>
      <AntDesign name="plus-circle" size={20} color="black" />
      <Text>{label}</Text>
    </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  container: {
    marginVertical: 15,
    flexDirection: 'row',
    gap: 5,
    alignContent: 'center'
  }
});

export default AddAnotherButton;
